import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3011/api';

const api = axios.create({
  baseURL: API_URL,
});

// Intercepteur pour ajouter le token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Intercepteur pour gerer les erreurs 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) => api.post('/auth/login', { email, password });
export const getMe = () => api.get('/auth/me');
export const getUsers = () => api.get('/auth/users');
export const createUser = (data) => api.post('/auth/users', data);
export const updateUser = (id, data) => api.put(`/auth/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/auth/users/${id}`);

// Pages
export const getPages = (params) => api.get('/pages', { params });
export const getPage = (id) => api.get(`/pages/${id}`);
export const createPage = (data) => api.post('/pages', data);
export const updatePage = (id, data) => api.put(`/pages/${id}`, data);
export const deletePage = (id) => api.delete(`/pages/${id}`);

// Articles
export const getArticles = (params) => api.get('/articles', { params });
export const getArticle = (id) => api.get(`/articles/${id}`);
export const createArticle = (data) => api.post('/articles', data);
export const updateArticle = (id, data) => api.put(`/articles/${id}`, data);
export const deleteArticle = (id) => api.delete(`/articles/${id}`);

// Categories
export const getCategories = () => api.get('/categories');
export const createCategory = (data) => api.post('/categories', data);
export const updateCategory = (id, data) => api.put(`/categories/${id}`, data);
export const deleteCategory = (id) => api.delete(`/categories/${id}`);

// Centres
export const getCentres = (params) => api.get('/centres', { params });
export const getCentre = (id) => api.get(`/centres/${id}`);
export const createCentre = (data) => api.post('/centres', data);
export const updateCentre = (id, data) => api.put(`/centres/${id}`, data);
export const deleteCentre = (id) => api.delete(`/centres/${id}`);

// Temoignages
export const getTemoignages = (params) => api.get('/temoignages', { params });
export const getTemoignage = (id) => api.get(`/temoignages/${id}`);
export const moderateTemoignage = (id, data) => api.put(`/temoignages/${id}/moderate`, data);
export const deleteTemoignage = (id) => api.delete(`/temoignages/${id}`);

// Media
export const getMedia = (params) => api.get('/media', { params });
export const uploadMedia = (formData) => api.post('/media/upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const deleteMedia = (id) => api.delete(`/media/${id}`);

export default api;
